import React from "react";
import Clickable from "./Clickable";

interface TopBarProps {
    children?: React.ReactNode;
    onClickPrevArrow?: () => void;
    endPart?: React.ReactNode;
    className?: string;
}

const TopBar : React.FC<TopBarProps> = ({ children, onClickPrevArrow, endPart, className }) => {
    const renderArrow = () => {
        return <div className="w-[50px] children-top-bar-equal">
            {
                onClickPrevArrow && (
                    <Clickable 
                        onClick={onClickPrevArrow}
                        className="h-[50px] w-[50px] rounded-xl flex items-center justify-center bg-brand-bg-5"
                    >
                        <i className="material-icons">arrow_back</i>
                    </Clickable>
                )
            }
        </div>
    }

    const getClassName = () => {
        return `
            flex
            items-center
            gap-2
            ${endPart ? "justify-between container-top-bar-equal" : "justify-start"}
            min-h-[80px]
            bg-brand-bg-4
            shrink-0
            ${className}
        `
    }

    if(endPart) {
        return (
            <div className={getClassName()}>
                {onClickPrevArrow ? renderArrow() : <div className="w-[10px] children-top-bar-equal"></div>}
                {children}
                <div className="h-full flex items-center justify-end children-top-bar-equal">{endPart}</div>
            </div>
        )
    }
    return (
        <div className={getClassName()}>
            {onClickPrevArrow ? renderArrow() : <div className="w-[10px] children-top-bar-equal"></div>}
            {children}
        </div>
    )
}

export default TopBar;